module.exports = __webpack_public_path__ + "static/img/news_06.1802c27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_06.jpg
// module id = F0vU
// module chunks = 2